module.exports = __webpack_public_path__ + "img/menu-close.6a978cb8.svg";